import { Logger } from 'typescript-log'
import { httpGet } from '../../helpers'
import { validateKeyTypes } from '../../helpers/validation'
import { EpaperPublicationType } from './epaper-loader-defination'

export async function getLatestIssuesFromMultiplePublications({
    logger,
    publications,
    caller,
}: {
    logger: Logger
    publications: EpaperPublicationType[]
    caller: string
}) {
    const data = await Promise.all(
        publications.map(async (publication) => {
            const cuePublication =
                InternalPulicationToCuePublicationMap[publication]

            const issues = await getLatestIssuesFromPublication({
                logger: logger,
                caller: caller,
                numberOfIssues: 1,
                publication: cuePublication,
            })
            return {
                ...issues.latestIssues[0],
                publicationName: publication,
                isPremium: PremiumPublicationsSet[publication],
            }
        }),
    )

    return data
}

export async function getLatestIssuesFromPublication({
    logger,
    publication,
    numberOfIssues,
    caller,
}: {
    logger: Logger
    publication: string
    numberOfIssues: number
    caller: string
}) {
    const data = await httpGet({
        log: logger,
        validate: validateGetEPaper,
        baseUrl: `http://cue-digital-sandbox.wanews.com.au`,
        path: `ccidist-ws/wan/${publication}/issues`,
        query: {
            draft: false,
            json: true,
            limit: numberOfIssues,
            skipSections: false,
            sortBy: `created`,
            sortOrder: `desc`,
            start: 1,
            submit: 'submit',
        },
        customHeaders: {
            caller,
        },
    })

    // const data = require('./sampleData.json') as EPaperResponseDTO

    const issues = data.issues.web

    const result: { latestIssues: Issue[] } = { latestIssues: [] }

    issues.forEach(function (item) {
        //we realistically shoulnd't have more than 1 section
        const { coverImageSmallUri, coverImageThumbnailUri, readerUrl } =
            item.sections[0]
        result.latestIssues.push({
            date: new Date(item.publishedDate),
            coverUrl: coverImageSmallUri,
            coverTumbnailUrl: coverImageThumbnailUri,
            url: readerUrl,
        })
    })

    return result
}

//this probably isn't enough validation
export function validateGetEPaper(value: any): EPaperResponseDTO {
    const errors = validateKeyTypes('curation', value, {
        organizationTitle: 'string',
        id: 'string',
        title: 'string',
    })

    if (errors) {
        throw new Error('EPaper response invalid\n    ' + errors.join('    \n'))
    }

    return value
}

export type Issue = {
    date: Date
    coverUrl: string
    coverTumbnailUrl: string
    url: string
    publicationName?: EpaperPublicationType
    isPremium?: boolean
}

interface EPaperResponseDTO {
    organizationTitle: string
    id: string
    title: string
    issues: { [key in 'web' | 'ios' | 'android']: IssueData[] }
}

interface IssueData {
    pageCount: number
    downloadPagesUrl: string
    coverImageSmallUri: string
    os: 'web' | 'android' | 'ios'
    coverImageUri: string
    published: 1
    updatedDate: Date
    title: string
    url: string //not the url to the reader
    sections: [
        {
            sectionName: string
            coverImageThumbnailUri: string
            coverImageSmallUri: string
            coverImageUri: string
            readerUrl: string
        },
    ]
    coverImageThumbnailUri: string
    publicUrl: string
    readerUrl: string
    publishedDate: Date
}

export const PremiumPublicationsSet: {
    [key in EpaperPublicationType]: boolean
} = {
    'albany-advertiser': true,
    'augusta-margaret-river-times': false,
    'broome-advertiser': false,
    'bunbury-herald': false,
    'busselton-dunsborough-times': false,
    countryman: true,
    'geraldton-guardian': true,
    'great-southern-herald': true,
    'harvey-waroona-reporter': false,
    'kalgoorlie-miner': true,
    'the-kimberley-echo': true,
    'manjimup-bridgetown-times': true,
    'midwest-times': false,
    'narrogin-observer': true,
    'north-west-telegraph': false,
    'pilbara-news': false,
    'sound-telegraph': false,
    'south-western-times': true,
    default: true,
    perthnow: false,
}

export const InternalPulicationToCuePublicationMap: {
    [key in EpaperPublicationType]: string
} = {
    'albany-advertiser': 'wan_west-australian',
    'broome-advertiser': 'wan_west-australian',
    'kalgoorlie-miner': 'wan_west-australian',
    'pilbara-news': 'wan_west-australian',
    'sound-telegraph': 'wan_west-australian',
    'south-western-times': 'wan_west-australian',
    'the-kimberley-echo': 'wan_west-australian',
    countryman: 'wan_west-australian',
    default: 'wan_west-australian',
    'augusta-margaret-river-times': 'wan_west-australian',
    'bunbury-herald': 'wan_west-australian',
    'busselton-dunsborough-times': 'wan_west-australian',
    'geraldton-guardian': 'wan_west-australian',
    'great-southern-herald': 'wan_west-australian',
    'harvey-waroona-reporter': 'wan_west-australian',
    'manjimup-bridgetown-times': 'wan_west-australian',
    'midwest-times': 'wan_west-australian',
    'narrogin-observer': 'wan_west-australian',
    'north-west-telegraph': 'wan_west-australian',
    perthnow: 'wan_west-australian',
}
